<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Resource Costing</h1>
    <p>Some companies require their staffs earnings to be costed based on their department, or location of work.</p>
    <p>Would you like to discuss resource costing requirements?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.requiresResourceCosting">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.requiresResourceCosting">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.requiresResourceCosting === undefined || props.formData.requiresResourceCosting === null || props.formData.requiresResourceCosting === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}


const executeStep = async () => {
  return true;
}



defineExpose({ validateStep, executeStep });

</script>